export var PostKind;
(function (PostKind) {
    PostKind[PostKind["POST"] = 0] = "POST";
    PostKind[PostKind["LINK"] = 1] = "LINK";
    PostKind[PostKind["FILE"] = 2] = "FILE";
    PostKind[PostKind["EVENT"] = 3] = "EVENT";
    PostKind[PostKind["POLL"] = 4] = "POLL";
    PostKind[PostKind["INVITATION"] = 5] = "INVITATION";
})(PostKind || (PostKind = {}));
